export const generateYearOptions = (startYear = 2019, endYearOffset = 3) => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + endYearOffset;
  const years = [];

  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }

  return years;
};

export const formatYear = (year) => {
  const yearNum = parseInt(year, 10);
  const current = new Date().getFullYear();

  if (yearNum === current) {
    return `${year} (Current)`;
  }
  if (yearNum > current) {
    return `${year} (Future)`;
  }
  return String(year);
};

export const generateTargetYearOptions = (
  startYear = 2026,
  endYearOffset = 10,
) => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + endYearOffset;
  const years = [];

  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }
  return years;
};
